import { render, staticRenderFns } from "./AvailableSpaces.vue?vue&type=template&id=66758af9&scoped=true"
import script from "./AvailableSpaces.vue?vue&type=script&lang=js"
export * from "./AvailableSpaces.vue?vue&type=script&lang=js"
import style0 from "./AvailableSpaces.vue?vue&type=style&index=0&id=66758af9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66758af9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66758af9')) {
      api.createRecord('66758af9', component.options)
    } else {
      api.reload('66758af9', component.options)
    }
    module.hot.accept("./AvailableSpaces.vue?vue&type=template&id=66758af9&scoped=true", function () {
      api.rerender('66758af9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/availableSpaces/AvailableSpaces.vue"
export default component.exports